import api from "./api";

export const ListarTipoEstabelecimento = async () => {
  try {
    const estabelecimentos = await api.get(`/tipos-estabelecimentos/`);
    return estabelecimentos.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarTipoEstabelecimento = async (data) => {
  try {
    const tipo = await api.post("/tipos-estabelecimentos", data);
    return tipo.data;
  } catch (error) {
    throw error;
  }
};

export const EditarTipoEstabelecimento = async (data, id) => {
  try {
    const tipo = await api.put(`/tipos-estabelecimentos/${id}`, data);
    return tipo.data;
  } catch (error) {
    throw error;
  }
};

export const DeletarTipoEstabelecimento = async (id) => {
  try {
    const tipo = await api.delete(`/tipos-estabelecimentos/${id}`);
    return tipo.data;
  } catch (error) {
    throw error;
  }
};
